export default __webpack_public_path__ + "b3632cf390d3f822423cf1062a8794b4.png";